<template>
  <div class="master-table-type">
    <el-table
      width="100%"
      :data="result"
      :span-method="arraySpanMethod"
      v-show="isShow"
      :fit="true"
    >

      <!--  システム初期設定 -->
      <el-table-column
        class-name="col-6"
        :label="$t('label.system.menuChange.systemInit')"
      >
        <div slot-scope="scope" class="sys-init">
          <div :class="(scope.row.menuType == '0200' || scope.row.menuType == '2000') ? 'system-menu-name meeting-room-color' : (scope.row.menuType == '0400' ? 'system-menu-name fxdesk-color' : (scope.row.menuType == '0500' ? 'system-menu-name entrance-color' : 'system-menu-name'))">
            {{ scope.row.systemMenuName }}
          </div>
          <img class="sys-init-right" :src="require('@/assets/icon/polygon.svg')" alt="" />
        </div>
      </el-table-column>

      <!--  表示箇所 -->
      <el-table-column
        class-name="col-4"
        prop="displayArea"
        :label="$t('label.system.menuChange.displayArea')"
      />

      <!--  メニュー名 -->
      <el-table-column
        class-name="col-10"
        :label="$t('label.system.menuChange.menuName')"
      >
        <div slot-scope="scope" class="owner-menu-div">
          <el-checkbox v-model="scope.row.ownerMenuNameSettingFlag"  />
          <el-input
            :disabled="!scope.row.ownerMenuNameSettingFlag"
            :maxlength="scope.row.menuDigit"
            :class="!scope.row.ownerMenuNameSettingFlag ? 'new-input-style show-word-limt-input-iot disable-input' : 'new-input-style show-word-limt-input-iot'"
            show-word-limit
            v-model="scope.row.ownerMenuName">
          </el-input>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Configuration from "@/config/index";

export default {
  name: "MenuSearchResultBeautify",
  components: {
  },
  data() {
    return {
      imageSrc: Configuration["base.api.urls"],
    };
  },
  props: {
    result: Array,
    isShow: Boolean,
  },
  watch: {
    result: {
      deep: true,
      handler(val) {
        this.$emit("changeResult", val);
      }
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    arraySpanMethod({row, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        const currentName = row.systemMenuName;
        if  (currentName == "フロアマップ") {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
        if (rowIndex !== 0 && currentName == this.result[rowIndex - 1].systemMenuName) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        const colData = this.result.map(item => item.systemMenuName);
        const count = colData.filter(systemMenuName => systemMenuName === currentName).length;
        return [count, 1];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sys-init {
  display: flex;
  align-items: center;
  .system-menu-name {
    min-width: 180px;
    min-height: 36px;
    display: flex;
    align-items: center;
    background-color: #F7F7F2;
    border-radius: 8px;
    padding: 6px 8px;
  }
  .sys-init-right {
    margin-left: 32px;
    width: 14px;
    height: 14px;
  }
}

.owner-menu-div {
  display: flex;
  align-items: center;
  ::v-deep .el-checkbox {
    width: 26px;
    height: 26px;
  }
  ::v-deep .el-input  {
    background-color: #F2F2ED !important;
    width: 228px !important;
    height: 37px !important;
    margin-left: 16px;
  }
  ::v-deep .el-input__inner {
    background-color: #F2F2ED !important;
    width: 228px !important;
    height: 37px !important;
  }
}

.master-table-type::v-deep .el-table .col-6 {
  vertical-align: top;
}

.master-table-type::v-deep .el-table .el-table__header th .cell {
  font-weight: 300 !important;
}

.master-table-type::v-deep .el-table .cell {
  font-size: 14px;
}

.disable-input {
::v-deep .el-input__inner {
    color: rgb(184, 184, 179) !important;
  }
}
.meeting-room-color{
  background-color: rgba(220, 229, 230, 1) !important;
}
.fxdesk-color{
  background-color: rgba(220, 230, 221, 1) !important;
}
.entrance-color {
  background-color: rgba(230, 220, 229, 1) !important;
}
</style>
